"use strict";

(() => {
  const THUMBS_OPTIONS = {
    containScroll: 'trimSnaps',
    dragFree: true
  };
  const VIEWPORT_OPTIONS = {
    watchDrag: viewportWatchDragHandler
  };
  const AUTOHEIGHT_OPTIONS = {};
  const CLASSNAMES_OPTIONS = {
    selected: 'embla__slide--selected'
  };
  class ProductMediaSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      window.loadEmblaCarousel();
      if (!window.EmblaCarousel) return;
      this._thumbs = this.querySelector('[data-thumbs]');
      this._thumbsPrevBtn = this.querySelector('[data-thumbs-prev]');
      this._thumbsNextBtn = this.querySelector('[data-thumbs-next]');
      this._viewport = this.querySelector('[data-viewport]');
      this._viewportDots = this.querySelector('[data-viewport-dots]');
      if (this._viewport) {
        this._viewport.addEventListener('click', event => {
          if (!this._emblaViewport) return;
          if (event.target.nodeName !== 'IMG') return;
          if (event.target.closest('deferred-media,product-model')) return;
          event.preventDefault();
          event.stopPropagation();
          const modalContainer = document.getElementById(`ProductModal-${this.dataset.sectionId}`);
          const slidesThumbs = this?._emblaThumbs?.slideNodes();
          const selected = this._emblaViewport.selectedScrollSnap();
          const selectedThumb = slidesThumbs?.[selected]?.querySelector('button');
          const activeMedia = modalContainer?.querySelector(`[data-media-id="${selectedThumb?.dataset?.thumbsMedia}"]`);
          if (activeMedia) {
            activeMedia.scrollIntoView();
          }
          modalContainer?.classList.add('this-active');
        });
        this._emblaViewport = EmblaCarousel(this._viewport, VIEWPORT_OPTIONS, [EmblaCarouselAutoHeight(AUTOHEIGHT_OPTIONS), EmblaCarouselClassNames(CLASSNAMES_OPTIONS)]);
        const removeViewportSlideSelectHandlers = addViewportSlideSelectHandlers(this._emblaViewport);
        this._emblaViewport.on('destroy', removeViewportSlideSelectHandlers);
      }
      if (this._thumbs) {
        this._thumbs.addEventListener('focusin', event => {
          const prevTarget = event.relatedTarget;
          const newTarget = event.target;
          if (!prevTarget || !newTarget) {
            return;
          }
          const slidesInView = this._emblaThumbs.slidesInView();
          const prevIndex = prevTarget.dataset.index ? Number(prevTarget.dataset.index) : -1;
          const newIndex = newTarget.dataset.index ? Number(newTarget.dataset.index) : 9999;
          const maxIndex = this._emblaThumbs.slideNodes().length - 1;
          if (prevIndex === -1 && newIndex === 0) {
            this._emblaThumbs.scrollTo(0);
          } else if (prevIndex === -1 && newIndex === maxIndex) {
            this._emblaThumbs.scrollTo(maxIndex);
          } else if (prevIndex < newIndex && newIndex === slidesInView.slice(-1)[0]) {
            this._emblaThumbs.scrollNext(true);
          } else if (prevIndex > newIndex && newIndex === slidesInView[0]) {
            this._emblaThumbs.scrollPrev(true);
          }
        });
        this._emblaThumbs = EmblaCarousel(this._thumbs, THUMBS_OPTIONS);
        const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(this._emblaThumbs, this._emblaViewport);
        const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(this._emblaThumbs, this._emblaViewport);
        if (this._thumbsPrevBtn) {
          const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(this._emblaThumbs, this._thumbsPrevBtn, this._thumbsNextBtn);
          const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(this._emblaThumbs, this._thumbsPrevBtn, this._thumbsNextBtn);
          this._emblaViewport.on('destroy', removePrevNextBtnsClickHandlers).on('destroy', removeTogglePrevNextBtnsActive);
        }
        if (this._viewportDots) {
          const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(this._emblaViewport, this._viewportDots);
          this._emblaViewport.on('destroy', removeDotBtnsAndClickHandlers);
        }
        this._emblaThumbs.on('destroy', removeThumbBtnsClickHandlers).on('destroy', removeToggleThumbBtnsActive);
        this._emblaViewport.on('destroy', removeThumbBtnsClickHandlers).on('destroy', removeToggleThumbBtnsActive);
      }
    }
  }
  function addThumbBtnsClickHandlers(emblaApiThumb, emblaApiMain) {
    const slidesThumbs = emblaApiThumb.slideNodes();
    const scrollToIndex = slidesThumbs.map((_, index) => () => {
      emblaApiMain.scrollTo(index);
      setTimeout(() => {
        pauseAllMedia(emblaApiMain.rootNode());
      }, 0);
    });
    slidesThumbs.forEach((slideNode, index) => {
      slideNode.addEventListener('click', scrollToIndex[index], false);
    });
    return () => {
      slidesThumbs.forEach((slideNode, index) => {
        slideNode.removeEventListener('click', scrollToIndex[index], false);
      });
    };
  }
  function addToggleThumbBtnsActive(emblaApiThumb, emblaApiMain) {
    const slidesThumbs = emblaApiThumb.slideNodes();
    const toggleThumbBtnsState = () => {
      emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
      const previous = emblaApiMain.previousScrollSnap();
      const selected = emblaApiMain.selectedScrollSnap();
      slidesThumbs[previous].classList.remove('embla-thumbs__slide--selected');
      slidesThumbs[selected].classList.add('embla-thumbs__slide--selected');
    };
    emblaApiMain.on('select', toggleThumbBtnsState);
    emblaApiThumb.on('init', toggleThumbBtnsState);
    return () => {
      const selected = emblaApiMain.selectedScrollSnap();
      slidesThumbs[selected].classList.remove('embla-thumbs__slide--selected');
    };
  }
  function addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn) {
    const scrollPrev = () => {
      emblaApi.scrollTo(emblaApi.selectedScrollSnap() - 2);
    };
    const scrollNext = () => {
      emblaApi.scrollTo(emblaApi.selectedScrollSnap() + 2);
    };
    prevBtn.addEventListener('click', scrollPrev, false);
    nextBtn.addEventListener('click', scrollNext, false);
    return () => {
      prevBtn.removeEventListener('click', scrollPrev, false);
      nextBtn.removeEventListener('click', scrollNext, false);
    };
  }
  function addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn) {
    const togglePrevNextBtnsState = () => {
      if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');else prevBtn.setAttribute('disabled', 'disabled');
      if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');else nextBtn.setAttribute('disabled', 'disabled');
    };
    emblaApi.on('select', togglePrevNextBtnsState).on('init', togglePrevNextBtnsState).on('reInit', togglePrevNextBtnsState);
    return () => {
      prevBtn.removeAttribute('disabled');
      nextBtn.setAttribute('disabled', 'disabled');
    };
  }
  function addDotBtnsAndClickHandlers(emblaApi, dotsNode) {
    let dotNodes = [];
    const addDotBtnsWithClickHandlers = () => {
      dotsNode.innerHTML = emblaApi.scrollSnapList().map(() => '<button class="embla__dot" type="button" aria-hidden="true"></button>').join('');
      dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
      dotNodes.forEach((dotNode, index) => {
        dotNode.addEventListener('click', () => {
          emblaApi.scrollTo(index);
          setTimeout(() => {
            pauseAllMedia(emblaApi.rootNode());
          }, 0);
        }, false);
      });
    };
    const toggleDotBtnsActive = () => {
      const previous = emblaApi.previousScrollSnap();
      const selected = emblaApi.selectedScrollSnap();
      dotNodes[previous].classList.remove('embla__dot--selected');
      dotNodes[selected].classList.add('embla__dot--selected');
    };
    emblaApi.on('init', addDotBtnsWithClickHandlers).on('reInit', addDotBtnsWithClickHandlers).on('init', toggleDotBtnsActive).on('reInit', toggleDotBtnsActive).on('select', toggleDotBtnsActive);
    return () => {
      dotsNode.innerHTML = '';
    };
  }
  function addViewportSlideSelectHandlers(emblaApi) {
    const eventHandler = () => {
      setTimeout(() => {
        pauseAllMedia(emblaApi.rootNode());
      }, 0);
    };
    emblaApi.on('select', eventHandler);
    return () => {
      emblaApi.off('select', eventHandler);
    };
  }
  function pauseAllMedia(containerNode) {
    if (!containerNode) return;
    containerNode.querySelectorAll('video').forEach(video => {
      video.pause();
    });
    containerNode.querySelectorAll('.js-youtube').forEach(video => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    containerNode.querySelectorAll('.js-vimeo').forEach(video => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    containerNode.querySelectorAll('product-model').forEach(model => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
  function viewportWatchDragHandler(emblaApi) {
    const slideNodes = emblaApi.slideNodes();
    const slideIndex = emblaApi.slidesInView()[0];
    const currentSlide = slideNodes[slideIndex];
    const allowToDrag = currentSlide.querySelector('video,.js-youtube,.js-vimeo,model-viewer') ? false : true;
    return allowToDrag;
  }
  if (!window.loadEmblaCarousel) {
    window.loadEmblaCarousel = function () {
      if (window.EmblaCarousel) return;

      /*!
       * Embla Carousel v8.0.0-rc06
       * (c) David Jerleke (https://github.com/davidjerleke/embla-carousel)
       * Released under the MIT License.
       */
      !function (n, t) {
        "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (n = "undefined" != typeof globalThis ? globalThis : n || self).EmblaCarousel = t();
      }(this, function () {
        "use strict";

        function n(n) {
          return "number" == typeof n;
        }
        function t(n) {
          return "string" == typeof n;
        }
        function e(n) {
          return "boolean" == typeof n;
        }
        function r(n) {
          return "[object Object]" === Object.prototype.toString.call(n);
        }
        function o(n) {
          return Math.abs(n);
        }
        function i(n) {
          return Math.sign(n);
        }
        function c(n, t) {
          return o(n - t);
        }
        function u(n) {
          return l(n).map(Number);
        }
        function s(n) {
          return n[a(n)];
        }
        function a(n) {
          return Math.max(0, n.length - 1);
        }
        function l(n) {
          return Object.keys(n);
        }
        function d(n, t) {
          return [n, t].reduce((n, t) => (l(t).forEach(e => {
            const o = n[e],
              i = t[e],
              c = r(o) && r(i);
            n[e] = c ? d(o, i) : i;
          }), n), {});
        }
        function f(n, t) {
          return void 0 !== t.MouseEvent && n instanceof t.MouseEvent;
        }
        function p(t, e) {
          const r = {
            start: function () {
              return 0;
            },
            center: function (n) {
              return o(n) / 2;
            },
            end: o
          };
          function o(n) {
            return e - n;
          }
          return {
            measure: function (o) {
              return n(t) ? e * Number(t) : r[t](o);
            }
          };
        }
        function m(n, t) {
          const e = o(n - t);
          function r(t) {
            return t < n;
          }
          function i(n) {
            return n > t;
          }
          function c(n) {
            return r(n) || i(n);
          }
          return {
            length: e,
            max: t,
            min: n,
            constrain: function (e) {
              return c(e) ? r(e) ? n : t : e;
            },
            reachedAny: c,
            reachedMax: i,
            reachedMin: r,
            removeOffset: function (n) {
              return e ? n - e * Math.ceil((n - t) / e) : n;
            }
          };
        }
        function g(n, t, e) {
          const {
              constrain: r
            } = m(0, n),
            i = n + 1;
          let c = u(t);
          function u(n) {
            return e ? o((i + n) % i) : r(n);
          }
          function s() {
            return c;
          }
          function a() {
            return g(n, s(), e);
          }
          const l = {
            get: s,
            set: function (n) {
              return c = u(n), l;
            },
            add: function (n) {
              return a().set(s() + n);
            },
            clone: a
          };
          return l;
        }
        function h() {
          let n = [];
          const t = {
            add: function (e, r, o) {
              let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                passive: !0
              };
              return e.addEventListener(r, o, i), n.push(() => e.removeEventListener(r, o, i)), t;
            },
            clear: function () {
              n = n.filter(n => n());
            }
          };
          return t;
        }
        function x(n, t, r, u, s, a, l, d, p, g, x, y, v, b, S, w, E, D, M) {
          const {
              cross: A
            } = n,
            I = ["INPUT", "SELECT", "TEXTAREA"],
            O = {
              passive: !1
            },
            P = h(),
            T = h(),
            z = m(50, 225).constrain(S.measure(20)),
            B = {
              mouse: 300,
              touch: 400
            },
            F = {
              mouse: 500,
              touch: 600
            },
            L = w ? 43 : 25;
          let k = !1,
            H = 0,
            R = 0,
            N = !1,
            C = !1,
            V = !1,
            j = !1;
          function q(n) {
            const e = l.readPoint(n),
              r = l.readPoint(n, A),
              o = c(e, H),
              i = c(r, R);
            if (!C && !j) {
              if (!n.cancelable) return U(n);
              if (C = o > i, !C) return U(n);
            }
            const u = l.pointerMove(n);
            o > E && (V = !0), x.useFriction(.3).useDuration(1), p.start(), a.add(t.apply(u)), n.preventDefault();
          }
          function U(n) {
            const e = y.byDistance(0, !1).index !== v.get(),
              r = l.pointerUp(n) * (w ? F : B)[j ? "mouse" : "touch"],
              u = function (n, t) {
                const e = v.add(-1 * i(n)),
                  r = y.byDistance(n, !w).distance;
                return w || o(n) < z ? r : D && t ? .5 * r : y.byIndex(e.get(), 0).distance;
              }(t.apply(r), e),
              s = function (n, t) {
                if (0 === n || 0 === t) return 0;
                if (o(n) <= o(t)) return 0;
                const e = c(o(n), o(t));
                return o(e / n);
              }(r, u),
              a = L - 10 * s,
              d = M + s / 50;
            C = !1, N = !1, T.clear(), x.useDuration(a).useFriction(d), g.distance(u, !w), j = !1, b.emit("pointerUp");
          }
          function W(n) {
            V && (n.stopPropagation(), n.preventDefault());
          }
          return {
            init: function (n, t) {
              if (!t) return;
              function o(o) {
                (e(t) || t(n, o)) && function (n) {
                  const t = f(n, s);
                  if (j = t, t && 0 !== n.button) return;
                  if (function (n) {
                    const t = n.nodeName || "";
                    return I.includes(t);
                  }(n.target)) return;
                  V = w && t && !n.buttons && k, k = c(a.get(), d.get()) >= 2, N = !0, l.pointerDown(n), x.useFriction(0).useDuration(0), a.set(d), function () {
                    const n = j ? u : r;
                    T.add(n, "touchmove", q, O).add(n, "touchend", U).add(n, "mousemove", q, O).add(n, "mouseup", U);
                  }(), H = l.readPoint(n), R = l.readPoint(n, A), b.emit("pointerDown");
                }(o);
              }
              const i = r;
              P.add(i, "dragstart", n => n.preventDefault(), O).add(i, "touchmove", () => {}, O).add(i, "touchend", () => {}).add(i, "touchstart", o).add(i, "mousedown", o).add(i, "touchcancel", U).add(i, "contextmenu", U).add(i, "click", W, !0);
            },
            pointerDown: function () {
              return N;
            },
            destroy: function () {
              P.clear(), T.clear();
            }
          };
        }
        function y(n, t) {
          let e, r;
          function i(n) {
            return n.timeStamp;
          }
          function c(e, r) {
            const o = "client" + ("x" === (r || n.scroll) ? "X" : "Y");
            return (f(e, t) ? e : e.touches[0])[o];
          }
          return {
            pointerDown: function (n) {
              return e = n, r = n, c(n);
            },
            pointerMove: function (n) {
              const t = c(n) - c(r),
                o = i(n) - i(e) > 170;
              return r = n, o && (e = n), t;
            },
            pointerUp: function (n) {
              if (!e || !r) return 0;
              const t = c(r) - c(e),
                u = i(n) - i(e),
                s = i(n) - i(r) > 170,
                a = t / u;
              return u && !s && o(a) > .1 ? a : 0;
            },
            readPoint: c
          };
        }
        function v(n, t, r, o) {
          let i,
            c,
            u = [],
            s = !1;
          function a(n) {
            return r.measureSize(n.getBoundingClientRect());
          }
          return {
            init: function (r, l) {
              if (!l) return;
              c = a(n), u = t.map(a), i = new ResizeObserver(i => {
                s || (e(l) || l(r, i)) && function (e) {
                  for (const i of e) {
                    const e = i.target === n,
                      s = t.indexOf(i.target);
                    if ((e ? c : u[s]) !== a(e ? n : t[s])) {
                      r.reInit(), o.emit("resize");
                      break;
                    }
                  }
                }(i);
              }), [n].concat(t).forEach(n => i.observe(n));
            },
            destroy: function () {
              i && i.disconnect(), s = !0;
            }
          };
        }
        function b(n, t, e, r, i) {
          const c = i.measure(10),
            u = i.measure(50),
            s = m(.1, .99);
          let a = !1;
          return {
            constrain: function (i) {
              if (a || !n.reachedAny(e.get()) || !n.reachedAny(t.get())) return;
              const l = n.reachedMin(t.get()) ? "min" : "max",
                d = o(n[l] - t.get()),
                f = e.get() - t.get(),
                p = s.constrain(d / u);
              e.subtract(f * p), !i && o(f) < c && (e.set(n.constrain(e.get())), r.useDuration(25).useBaseFriction());
            },
            toggleActive: function (n) {
              a = !n;
            }
          };
        }
        function S(n, t, e, r) {
          const o = m(-t + n, e[0]),
            i = e.map(o.constrain).map(n => parseFloat(n.toFixed(3)));
          return {
            snapsContained: function () {
              if (t <= n) return [o.max];
              if ("keepSnaps" === r) return i;
              const {
                min: e,
                max: c
              } = function () {
                const n = i[0],
                  t = s(i),
                  e = i.lastIndexOf(n),
                  r = i.indexOf(t) + 1;
                return m(e, r);
              }();
              return i.slice(e, c);
            }()
          };
        }
        function w(n, t, e, r) {
          const o = t.min + .1,
            i = t.max + .1,
            {
              reachedMin: c,
              reachedMax: u
            } = m(o, i);
          return {
            loop: function (t) {
              if (!function (n) {
                return 1 === n ? u(e.get()) : -1 === n && c(e.get());
              }(t)) return;
              const o = n * (-1 * t);
              r.forEach(n => n.add(o));
            }
          };
        }
        function E(n) {
          const {
            max: t,
            length: e
          } = n;
          return {
            get: function (n) {
              return (n - t) / -e;
            }
          };
        }
        function D(n, t, e, r, c) {
          const {
            reachedAny: u,
            removeOffset: s,
            constrain: a
          } = r;
          function l(n) {
            return n.concat().sort((n, t) => o(n) - o(t))[0];
          }
          function d(t, r) {
            const o = [t, t + e, t - e];
            if (!n) return o[0];
            if (!r) return l(o);
            return l(o.filter(n => i(n) === r));
          }
          return {
            byDistance: function (e, r) {
              const i = c.get() + e,
                {
                  index: l,
                  distance: f
                } = function (e) {
                  const r = n ? s(e) : a(e),
                    i = t.map(n => n - r).map(n => d(n, 0)).map((n, t) => ({
                      diff: n,
                      index: t
                    })).sort((n, t) => o(n.diff) - o(t.diff)),
                    {
                      index: c
                    } = i[0];
                  return {
                    index: c,
                    distance: r
                  };
                }(i),
                p = !n && u(i);
              return !r || p ? {
                index: l,
                distance: e
              } : {
                index: l,
                distance: e + d(t[l] - f, 0)
              };
            },
            byIndex: function (n, e) {
              return {
                index: n,
                distance: d(t[n] - c.get(), e)
              };
            },
            shortcut: d
          };
        }
        function M(t) {
          let e = t;
          function r(t) {
            return n(t) ? t : t.get();
          }
          return {
            get: function () {
              return e;
            },
            set: function (n) {
              e = r(n);
            },
            add: function (n) {
              e += r(n);
            },
            subtract: function (n) {
              e -= r(n);
            }
          };
        }
        function A(n, t, e) {
          const r = "x" === n.scroll ? function (n) {
              return `translate3d(${n}px,0px,0px)`;
            } : function (n) {
              return `translate3d(0px,${n}px,0px)`;
            },
            o = e.style;
          let i = !1;
          return {
            clear: function () {
              i || (o.transform = "", e.getAttribute("style") || e.removeAttribute("style"));
            },
            to: function (n) {
              i || (o.transform = r(t.apply(n)));
            },
            toggleActive: function (n) {
              i = !n;
            }
          };
        }
        function I(n, t, e, r, o, i, c, s, a) {
          const l = u(o),
            d = u(o).reverse(),
            f = function () {
              const n = i[0] - 1;
              return g(m(d, n), "end");
            }().concat(function () {
              const n = e - i[0] - 1;
              return g(m(l, n), "start");
            }());
          function p(n, t) {
            return n.reduce((n, t) => n - o[t], t);
          }
          function m(n, t) {
            return n.reduce((n, e) => p(n, t) > 0 ? n.concat([e]) : n, []);
          }
          function g(e, o) {
            const i = "start" === o,
              u = i ? -r : r,
              l = c.findSlideBounds([u]);
            return e.map(e => {
              const o = i ? 0 : -r,
                c = i ? r : 0,
                u = l.filter(n => n.index === e)[0][i ? "end" : "start"],
                d = M(-1),
                f = A(n, t, a[e]);
              return {
                index: e,
                location: d,
                translate: f,
                target: () => s.get() > u ? o : c
              };
            });
          }
          return {
            canLoop: function () {
              return f.every(_ref => {
                let {
                  index: n
                } = _ref;
                return p(l.filter(t => t !== n), e) <= .1;
              });
            },
            clear: function () {
              f.forEach(n => n.translate.clear());
            },
            loop: function () {
              f.forEach(n => {
                const {
                    target: t,
                    translate: e,
                    location: r
                  } = n,
                  o = t();
                o !== r.get() && (e.to(o), r.set(o));
              });
            },
            loopPoints: f
          };
        }
        function O(n, t) {
          let r,
            o = !1;
          return {
            init: function (i, c) {
              c && (r = new MutationObserver(n => {
                o || (e(c) || c(i, n)) && function (n) {
                  for (const e of n) if ("childList" === e.type) {
                    i.reInit(), t.emit("slidesChanged");
                    break;
                  }
                }(n);
              }), r.observe(n, {
                childList: !0
              }));
            },
            destroy: function () {
              r && r.disconnect(), o = !0;
            }
          };
        }
        function P(n, t, e, r, o, i, c) {
          const {
              removeOffset: u,
              constrain: s
            } = o,
            a = i ? [0, t, -t] : [0],
            l = d(a, c);
          function d(t, o) {
            const i = t || a,
              c = function (n) {
                const t = n || 0;
                return e.map(n => m(.5, n - .5).constrain(n * t));
              }(o);
            return i.reduce((t, o) => {
              const i = r.map((t, r) => ({
                start: t - e[r] + c[r] + o,
                end: t + n - c[r] + o,
                index: r
              }));
              return t.concat(i);
            }, []);
          }
          return {
            check: function (n, t) {
              const e = i ? u(n) : s(n);
              return (t || l).reduce((n, t) => {
                const {
                  index: r,
                  start: o,
                  end: i
                } = t;
                return !n.includes(r) && o < e && i > e ? n.concat([r]) : n;
              }, []);
            },
            findSlideBounds: d
          };
        }
        function T(t, e, r) {
          const o = n(r);
          return {
            groupSlides: function (n) {
              return o ? function (n, t) {
                return u(n).filter(n => n % t == 0).map(e => n.slice(e, e + t));
              }(n, r) : function (n) {
                return u(n).reduce((n, r) => {
                  const o = e.slice(s(n), r + 1).reduce((n, t) => n + t, 0);
                  return !r || o > t ? n.concat(r) : n;
                }, []).map((t, e, r) => n.slice(t, r[e + 1]));
              }(n);
            }
          };
        }
        function z(n, t, e, r, c, l, d, f) {
          const {
              align: z,
              axis: B,
              direction: F,
              startIndex: L,
              inViewThreshold: k,
              loop: H,
              duration: R,
              dragFree: N,
              dragThreshold: C,
              slidesToScroll: V,
              skipSnaps: j,
              containScroll: q
            } = l,
            U = t.getBoundingClientRect(),
            W = e.map(n => n.getBoundingClientRect()),
            $ = function (n) {
              const t = "rtl" === n ? -1 : 1;
              return {
                apply: function (n) {
                  return n * t;
                }
              };
            }(F),
            G = function (n, t) {
              const e = "y" === n ? "y" : "x";
              return {
                scroll: e,
                cross: "y" === n ? "x" : "y",
                startEdge: "y" === e ? "top" : "rtl" === t ? "right" : "left",
                endEdge: "y" === e ? "bottom" : "rtl" === t ? "left" : "right",
                measureSize: function (n) {
                  const {
                    width: t,
                    height: r
                  } = n;
                  return "x" === e ? t : r;
                }
              };
            }(B, F),
            Q = G.measureSize(U),
            X = function (n) {
              return {
                measure: function (t) {
                  return n * (t / 100);
                }
              };
            }(Q),
            Y = p(z, Q),
            J = !H && !!q,
            K = H || !!q,
            {
              slideSizes: Z,
              slideSizesWithGaps: _
            } = function (n, t, e, r, i, c) {
              const {
                  measureSize: u,
                  startEdge: l,
                  endEdge: d
                } = n,
                f = e[0] && i,
                p = function () {
                  if (!f) return 0;
                  const n = e[0];
                  return o(t[l] - n[l]);
                }(),
                m = function () {
                  if (!f) return 0;
                  const n = c.getComputedStyle(s(r));
                  return parseFloat(n.getPropertyValue(`margin-${d}`));
                }(),
                g = e.map(u),
                h = e.map((n, t, e) => {
                  const r = !t,
                    o = t === a(e);
                  return r ? g[t] + p : o ? g[t] + m : e[t + 1][l] - n[l];
                }).map(o);
              return {
                slideSizes: g,
                slideSizesWithGaps: h
              };
            }(G, U, W, e, K, c),
            nn = T(Q, _, V),
            {
              snaps: tn,
              snapsAligned: en
            } = function (n, t, e, r, i, c, u) {
              const {
                  startEdge: l,
                  endEdge: d
                } = n,
                {
                  groupSlides: f
                } = c,
                p = f(r).map(n => s(n)[d] - n[0][l]).map(o).map(t.measure),
                m = r.map(n => e[l] - n[l]).map(n => -o(n)),
                g = function () {
                  const n = s(m) - s(i);
                  return f(m).map(n => n[0]).map((t, e, r) => {
                    const o = !e,
                      i = e === a(r);
                    return u && o ? 0 : u && i ? n : t + p[e];
                  });
                }();
              return {
                snaps: m,
                snapsAligned: g
              };
            }(G, Y, U, W, _, nn, J),
            rn = -s(tn) + s(_),
            {
              snapsContained: on
            } = S(Q, rn, en, q),
            cn = J ? on : en,
            {
              limit: un
            } = function (n, t, e) {
              const r = t[0];
              return {
                limit: m(e ? r - n : s(t), r)
              };
            }(rn, cn, H),
            sn = g(a(cn), L, H),
            an = sn.clone(),
            ln = u(e),
            dn = {
              update: () => (_ref2 => {
                let {
                  dragHandler: n,
                  scrollBody: t,
                  scrollBounds: e,
                  scrollLooper: r,
                  slideLooper: o,
                  eventHandler: i,
                  animation: c,
                  options: {
                    loop: u
                  }
                } = _ref2;
                const s = n.pointerDown();
                u || e.constrain(s);
                const a = t.seek().settled();
                a && !s && (c.stop(), i.emit("settle")), a || i.emit("scroll"), u && (r.loop(t.direction()), o.loop());
              })(vn),
              render: n => ((_ref3, r) => {
                let {
                  scrollBody: n,
                  translate: t,
                  location: e
                } = _ref3;
                const o = n.velocity(),
                  i = e.get() - o + o * r;
                t.to(i);
              })(vn, n),
              start: () => f.start(vn),
              stop: () => f.stop(vn)
            },
            fn = cn[sn.get()],
            pn = M(fn),
            mn = M(fn),
            gn = function (n, t, e, r) {
              let c = !0,
                u = 0,
                s = 0,
                a = e,
                l = r;
              function d(n) {
                return a = n, p;
              }
              function f(n) {
                return l = n, p;
              }
              const p = {
                direction: function () {
                  return s;
                },
                seek: function () {
                  const e = t.get() - n.get();
                  return l && a ? (u += e / a, u *= l, n.add(u)) : (u = 0, n.set(t)), s = i(u || e), c = o(e) < .001, p;
                },
                settled: function () {
                  return c && n.set(t), c;
                },
                useBaseFriction: function () {
                  return f(r);
                },
                useBaseDuration: function () {
                  return d(e);
                },
                useFriction: f,
                useDuration: d,
                velocity: function () {
                  return u;
                }
              };
              return p;
            }(pn, mn, R, .68),
            hn = D(H, cn, rn, un, mn),
            xn = function (n, t, e, r, o, i) {
              function c(r) {
                const c = r.distance,
                  u = r.index !== t.get();
                c && (n.start(), o.add(c)), u && (e.set(t.get()), t.set(r.index), i.emit("select"));
              }
              return {
                distance: function (n, t) {
                  c(r.byDistance(n, t));
                },
                index: function (n, e) {
                  const o = t.clone().set(n);
                  c(r.byIndex(o.get(), e));
                }
              };
            }(dn, sn, an, hn, mn, d),
            yn = P(Q, rn, Z, tn, un, H, k),
            vn = {
              ownerDocument: r,
              ownerWindow: c,
              eventHandler: d,
              containerRect: U,
              slideRects: W,
              animation: dn,
              axis: G,
              direction: $,
              dragHandler: x(G, $, n, r, c, mn, y(G, c), pn, dn, xn, gn, hn, sn, d, X, N, C, j, .68),
              eventStore: h(),
              percentOfView: X,
              index: sn,
              indexPrevious: an,
              limit: un,
              location: pn,
              options: l,
              resizeHandler: v(t, e, G, d),
              scrollBody: gn,
              scrollBounds: b(un, pn, mn, gn, X),
              scrollLooper: w(rn, un, pn, [pn, mn]),
              scrollProgress: E(un),
              scrollSnaps: cn,
              scrollTarget: hn,
              scrollTo: xn,
              slideLooper: I(G, $, Q, rn, _, cn, yn, pn, e),
              slidesHandler: O(t, d),
              slidesInView: yn,
              slideIndexes: ln,
              slidesToScroll: nn,
              target: mn,
              translate: A(G, $, t)
            };
          return vn;
        }
        const B = {
          align: "center",
          axis: "x",
          container: null,
          slides: null,
          containScroll: null,
          direction: "ltr",
          slidesToScroll: 1,
          breakpoints: {},
          dragFree: !1,
          dragThreshold: 10,
          inViewThreshold: 0,
          loop: !1,
          skipSnaps: !1,
          duration: 25,
          startIndex: 0,
          active: !0,
          watchDrag: !0,
          watchResize: !0,
          watchSlides: !0
        };
        function F(n) {
          function t(n, t) {
            return d(n, t || {});
          }
          const e = {
            mergeOptions: t,
            optionsAtMedia: function (e) {
              const r = e.breakpoints || {},
                o = l(r).filter(t => n.matchMedia(t).matches).map(n => r[n]).reduce((n, e) => t(n, e), {});
              return t(e, o);
            },
            optionsMediaQueries: function (t) {
              return t.map(n => l(n.breakpoints || {})).reduce((n, t) => n.concat(t), []).map(n.matchMedia);
            }
          };
          return e;
        }
        function L(n, e, r) {
          const i = n.ownerDocument,
            c = i.defaultView,
            u = F(c),
            s = function (n) {
              let t = [];
              return {
                init: function (e, r) {
                  return t = e.filter(_ref4 => {
                    let {
                      options: t
                    } = _ref4;
                    return !1 !== n.optionsAtMedia(t).active;
                  }), t.forEach(t => t.init(r, n)), e.reduce((n, t) => Object.assign(n, {
                    [t.name]: t
                  }), {});
                },
                destroy: function () {
                  t = t.filter(n => n.destroy());
                }
              };
            }(u),
            a = h(),
            l = h(),
            d = function () {
              const n = {};
              let t;
              function e(t) {
                return n[t] || [];
              }
              const r = {
                init: function (n) {
                  t = n;
                },
                emit: function (n) {
                  return e(n).forEach(e => e(t, n)), r;
                },
                off: function (t, o) {
                  return n[t] = e(t).filter(n => n !== o), r;
                },
                on: function (t, o) {
                  return n[t] = e(t).concat([o]), r;
                }
              };
              return r;
            }(),
            {
              animationRealms: f
            } = L,
            {
              mergeOptions: p,
              optionsAtMedia: m,
              optionsMediaQueries: g
            } = u,
            {
              on: x,
              off: y,
              emit: v
            } = d,
            b = T;
          let S,
            w,
            E,
            D,
            M = !1,
            A = p(B, L.globalOptions),
            I = p(A),
            O = [];
          function P(e, r) {
            if (M) return;
            const u = f.find(n => n.window === c),
              h = u || function (n) {
                const t = 1e3 / 60;
                let e = [],
                  r = null,
                  i = 0,
                  c = 0;
                function u(s) {
                  r || (r = s);
                  const a = s - r;
                  for (r = s, i += a; i >= t;) e.forEach(_ref5 => {
                    let {
                      animation: n
                    } = _ref5;
                    return n.update();
                  }), i -= t;
                  const l = o(i / t);
                  e.forEach(_ref6 => {
                    let {
                      animation: n
                    } = _ref6;
                    return n.render(l);
                  }), c && n.requestAnimationFrame(u);
                }
                return {
                  start: function (t) {
                    e.includes(t) || e.push(t), c || (c = n.requestAnimationFrame(u));
                  },
                  stop: function (t) {
                    e = e.filter(n => n !== t), e.length || (n.cancelAnimationFrame(c), r = null, i = 0, c = 0);
                  },
                  reset: function () {
                    r = null, i = 0;
                  },
                  window: n
                };
              }(c);
            if (u || f.push(h), A = p(A, e), I = m(A), O = r || O, function () {
              const {
                  container: e,
                  slides: r
                } = I,
                o = t(e) ? n.querySelector(e) : e;
              E = o || n.children[0];
              const i = t(r) ? E.querySelectorAll(r) : r;
              D = [].slice.call(i || E.children);
            }(), S = z(n, E, D, i, c, I, d, h), g([A, ...O.map(_ref7 => {
              let {
                options: n
              } = _ref7;
              return n;
            })]).forEach(n => a.add(n, "change", T)), I.active) {
              if (S.translate.to(S.location.get()), S.eventHandler.init(C), S.resizeHandler.init(C, I.watchResize), S.slidesHandler.init(C, I.watchSlides), l.add(i, "visibilitychange", () => {
                i.hidden && h.reset();
              }), I.loop) {
                if (!S.slideLooper.canLoop()) return k(), P({
                  loop: !1
                }, r), void (A = p(A, {
                  loop: !0
                }));
                S.slideLooper.loop();
              }
              E.offsetParent && D.length && S.dragHandler.init(C, I.watchDrag), w = s.init(O, C);
            }
          }
          function T(n, t) {
            const e = N();
            k(), P(p({
              startIndex: e
            }, n), t), d.emit("reInit");
          }
          function k() {
            S.dragHandler.destroy(), S.animation.stop(), S.eventStore.clear(), S.translate.clear(), S.slideLooper.clear(), S.resizeHandler.destroy(), S.slidesHandler.destroy(), s.destroy(), a.clear(), l.clear();
          }
          function H(n) {
            const t = S[n ? "target" : "location"].get(),
              e = I.loop ? "removeOffset" : "constrain";
            return S.slidesInView.check(S.limit[e](t));
          }
          function R(n, t, e) {
            I.active && !M && (S.scrollBody.useBaseFriction().useDuration(t ? 0 : I.duration), S.scrollTo.index(n, e || 0));
          }
          function N() {
            return S.index.get();
          }
          const C = {
            canScrollNext: function () {
              return S.index.add(1).get() !== N();
            },
            canScrollPrev: function () {
              return S.index.add(-1).get() !== N();
            },
            containerNode: function () {
              return E;
            },
            internalEngine: function () {
              return S;
            },
            destroy: function () {
              M || (M = !0, a.clear(), k(), d.emit("destroy"));
            },
            off: y,
            on: x,
            emit: v,
            plugins: function () {
              return w;
            },
            previousScrollSnap: function () {
              return S.indexPrevious.get();
            },
            reInit: b,
            rootNode: function () {
              return n;
            },
            scrollNext: function (n) {
              R(S.index.add(1).get(), !0 === n, -1);
            },
            scrollPrev: function (n) {
              R(S.index.add(-1).get(), !0 === n, 1);
            },
            scrollProgress: function () {
              return S.scrollProgress.get(S.location.get());
            },
            scrollSnapList: function () {
              return S.scrollSnaps.map(S.scrollProgress.get);
            },
            scrollTo: R,
            selectedScrollSnap: N,
            slideNodes: function () {
              return D;
            },
            slidesInView: H,
            slidesNotInView: function (n) {
              const t = H(n);
              return S.slideIndexes.filter(n => !t.includes(n));
            }
          };
          return P(e, r), setTimeout(() => d.emit("init"), 0), C;
        }
        return L.animationRealms = [], L.globalOptions = void 0, L;
      });

      // Embla Carousel auto height plugin
      !function (e, t) {
        "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).EmblaCarouselAutoHeight = t();
      }(this, function () {
        "use strict";

        const e = {
          active: !0,
          breakpoints: {},
          destroyHeight: "auto"
        };
        function t() {
          let n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          let o,
            i,
            s = [],
            d = [];
          const c = ["select", "pointerUp"];
          function r(e, t) {
            const n = "destroy" === t ? o.destroyHeight : `${function () {
              const {
                slidesInView: e,
                target: t
              } = i.internalEngine();
              return e.check(t.get(), s).map(e => d[e]).reduce((e, t) => Math.max(e, t), 0);
            }()}px`;
            i.containerNode().style.height = n;
          }
          return {
            name: "autoHeight",
            options: n,
            init: function (a, f) {
              i = a;
              const {
                  mergeOptions: l,
                  optionsAtMedia: u
                } = f,
                p = l(e, t.globalOptions),
                g = l(p, n);
              o = u(g);
              const {
                options: {
                  axis: h
                },
                slidesInView: y,
                slideRects: m
              } = i.internalEngine();
              "y" !== h && (s = y.findSlideBounds(void 0, .5), d = m.map(e => e.height), c.forEach(e => i.on(e, r)), r());
            },
            destroy: function () {
              c.forEach(e => i.off(e, r)), r(void 0, "destroy");
            }
          };
        }
        return t.globalOptions = void 0, t;
      });

      // Embla Carousel class names plugin
      !function (e, n) {
        "object" == typeof exports && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : (e = "undefined" != typeof globalThis ? globalThis : e || self).EmblaCarouselClassNames = n();
      }(this, function () {
        "use strict";

        const e = {
          active: !0,
          breakpoints: {},
          selected: "is-selected",
          draggable: "is-draggable",
          dragging: "is-dragging"
        };
        function n(e, n) {
          const o = e.classList;
          n && o.contains(n) && o.remove(n);
        }
        function o(e, n) {
          const o = e.classList;
          n && !o.contains(n) && o.add(n);
        }
        function t() {
          let i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          let s, a, c, d;
          const r = ["select", "pointerUp"],
            l = ["pointerDown", "pointerUp"];
          function f(e, t) {
            "pointerDown" === t ? o(c, s.dragging) : n(c, s.dragging);
          }
          function g() {
            const e = a.slidesInView(!0);
            a.slidesNotInView(!0).forEach(e => n(d[e], s.selected)), e.forEach(e => o(d[e], s.selected));
          }
          return {
            name: "classNames",
            options: i,
            init: function (n, p) {
              a = n;
              const {
                  mergeOptions: u,
                  optionsAtMedia: b
                } = p,
                h = u(e, t.globalOptions),
                m = u(h, i);
              s = b(m), c = a.rootNode(), d = a.slideNodes(), !!a.internalEngine().options.watchDrag && o(c, s.draggable), s.dragging && l.forEach(e => a.on(e, f)), s.selected && (r.forEach(e => a.on(e, g)), g());
            },
            destroy: function () {
              n(c, s.draggable), l.forEach(e => a.off(e, f)), r.forEach(e => a.off(e, g)), d.forEach(e => n(e, s.selected));
            }
          };
        }
        return t.globalOptions = void 0, t;
      });
    };
  }
  if (!customElements.get('product-media-slider')) {
    customElements.define('product-media-slider', ProductMediaSlider);
  }
})();